export function safeParse<T>(input: string | undefined): T | null {
  try {
    return JSON.parse(input || 'null') as T;
  } catch {
    return null;
  }
}
